import { ReactNode } from 'react';

export interface ActivityHistoryListProps {
  children: ReactNode;
}

export const ActivityHistoryList = ({ children }: ActivityHistoryListProps) => (
  <div className="flex flex-col gap-4">{children}</div>
);
